export default function ajax(json, url, type, fn) {
  return new Promise(function(resolve, reject) {
    var xhr = new XMLHttpRequest();
    xhr.onload = function() {
      if (this.status >= 200 && this.status < 300) {
        resolve(this.responseText);
      } else {
        reject(new Error(`Request failed with status ${this.status}: ${this.statusText}`));
      }
    };
    xhr.onerror = function() {
      reject(new Error('Network error'));
    };
    xhr.open('POST', url);
    xhr.setRequestHeader("Content-Type", "application/json;charset=UTF-8");
    xhr.setRequestHeader('X-Requested-With', 'XMLHttpRequest');
    if (type != null && type === "main") {
      if (fn !== null && typeof fn === "function") {
        xhr.onloadstart = fn();
      }
    }
    xhr.send(JSON.stringify(json));
  });
}
